module.exports = __webpack_public_path__ + "static/media/fal_fal_wor_pla.646a147a.png";